import { useEffect, useRef, useState } from "react";

export default function useElapsedTimer() {
    const [elapsedSeconds, setElapsedSeconds] = useState(0);

    const timerIntervalRef = useRef(null);
    const timerStartedAtRef = useRef(null);
    const accumulatedElapsedMsRef = useRef(0);

    function clearElapsedInterval() {
        if (timerIntervalRef.current) {
            clearInterval(timerIntervalRef.current);
            timerIntervalRef.current = null;
        }
    }

    function resetElapsedTimer() {
        clearElapsedInterval();
        timerStartedAtRef.current = null;
        accumulatedElapsedMsRef.current = 0;
        setElapsedSeconds(0);
    }

    function pauseElapsedTimer() {
        if (timerStartedAtRef.current !== null) {
            accumulatedElapsedMsRef.current += Date.now() - timerStartedAtRef.current;
            timerStartedAtRef.current = null;
        }

        clearElapsedInterval();
        setElapsedSeconds(Math.floor(accumulatedElapsedMsRef.current / 1000));
    }

    function restoreElapsedTimer(totalSeconds) {
        const normalizedTotalSeconds = Math.max(0, Number(totalSeconds) || 0);
        accumulatedElapsedMsRef.current = normalizedTotalSeconds * 1000;
        setElapsedSeconds(normalizedTotalSeconds);

        if (timerStartedAtRef.current !== null) {
            timerStartedAtRef.current = Date.now();
        }
    }

    function resumeElapsedTimer() {
        clearElapsedInterval();

        timerStartedAtRef.current = Date.now();
        timerIntervalRef.current = window.setInterval(() => {
            const elapsedMs = accumulatedElapsedMsRef.current + (Date.now() - timerStartedAtRef.current);
            setElapsedSeconds(Math.floor(elapsedMs / 1000));
        }, 250);
    }

    useEffect(() => {
        return () => {
            clearElapsedInterval();
        };
    }, []);

    return {
        elapsedSeconds,
        pauseElapsedTimer,
        resetElapsedTimer,
        restoreElapsedTimer,
        resumeElapsedTimer,
    };
}
